import { gql } from '@apollo/client';
import { UPLOAD_FIELDS } from '../fragments';

/**
 * Step one of the upload flow. The server validates the declared type and
 * size, then signs a URL for exactly that — so the limit is enforced by
 * Cloud Storage rather than trusted from the browser. The returned token
 * carries the object path; the client never constructs one.
 *
 * The file bytes no longer pass through the API at all, which is what the old
 * `createFile(file: Upload!)` multipart mutation did.
 */
export const CREATE_UPLOAD_URL = gql`
  mutation createUploadUrl($input: CreateUploadUrlInput!) {
    createUploadUrl(input: $input) {
      uploadUrl
      uploadToken
      expiresAt
    }
  }
`;

/** Step three, after the browser has PUT the bytes to the signed URL. */
export const CONFIRM_UPLOAD = gql`
  mutation confirmUpload($input: ConfirmUploadInput!) {
    confirmUpload(input: $input) {
      ...UploadFields
    }
  }
  ${UPLOAD_FIELDS}
`;

/**
 * Detaching a file. Replaces the nested `uploads.disconnect` the relational
 * update payload carried, which rode along on whatever authorization the
 * update itself had.
 */
export const REMOVE_UPLOAD = gql`
  mutation removeUpload($target: UploadTarget!, $targetId: String!, $uploadId: String!) {
    removeUpload(target: $target, targetId: $targetId, uploadId: $uploadId)
  }
`;
